var navbar = document.querySelector('nav')

if($('div').hasClass('x--navbar-spacer')){
  navbar.classList.remove('dva-navbar-topcolors')
  navbar.classList.add('dva-navbar-scrollcolors')
} else {
  window.onscroll = function() {
    var navbar_height = $('.dva-navbar').height()
    // pageYOffset or scrollY
    if (window.pageYOffset > navbar_height) {
      navbar.classList.remove('dva-navbar-topcolors')
      navbar.classList.add('dva-navbar-scrollcolors')
    } else {
      navbar.classList.remove('dva-navbar-scrollcolors')
      navbar.classList.add('dva-navbar-topcolors')
    }
  }
}
